module.exports = __webpack_public_path__ + "media/src/assets/Images/MessageTrash-0bf560c492b37e4dc312bc7924cef098.svg";